import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pnlTest',
    standalone: true
})

export class PnlPipe implements PipeTransform {

    constructor(private currencyPipe: CurrencyPipe) { }

    transform(value: number, currencyCode: string, suffix: boolean): string | null {
        let formattedPnl: string | null = null;

        if (suffix) {
            // Always $M, billions included, so a column of P&Ls reads in one unit.
            const million = 1000000;
            const hundredthousand = 100000;

            if (Math.abs(value) > hundredthousand) {
                formattedPnl = this.currencyPipe.transform(value / million, currencyCode) + 'M';
            }
        }

        if (!formattedPnl) {
            formattedPnl =  this.currencyPipe.transform(value, currencyCode);
        }

        if (value > 0) {
            return `+${formattedPnl}`;
        }

        return formattedPnl;
    }
}